import {AfterContentInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ThemePalette} from '@angular/material/core';
import {Select, Store} from '@ngxs/store';
import {MapState, PaymentKeyState} from 'src/app/components/shared/map.state';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {SetPaymentStepSecureEft} from '../../shared/map.actions.js';
import {Session} from 'src/app/interfaces/session-data.js';
import {InputSelectAccountObject} from 'src/app/interfaces/secure-eft/Eftx';

declare global {
  interface Window {
    Eftx: any;
  }
}

window.Eftx = window.Eftx || {};
declare let Eftx: Function;
@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss'],
})
export class SecureEftTransactionComponent implements OnInit, AfterContentInit, OnDestroy {
  // box-shadow
  public boxShadow = '0px 6px 12px 0px rgba(0,0,0,0.5 )';

  // ngxs state management
  @Select(PaymentKeyState) paymentkey$: Observable<object>;
  @Select(MapState.sessionStorage) sessionStorage$: Observable<Session>;
  @ViewChild('payButton') payButton;
  @ViewChild('payButton2') payButton2;
  // loader
  diameter = 70;
  color: ThemePalette = 'primary';
  loading = false;
  // account selection object array var
  options = [];
  popupWindowTime: number = 5;
  popupOpened: boolean = false;
  reopenPopup: boolean = false;
  themeColour;

  // payment card step controller
  step = '';

  // payment key holder
  key;

  // eftx var
  eftxHolder = undefined;

  // bank selected bool
  public bankSelected = false;

  // when account selection step
  accountSelection = false;

  showButtons = true;

  session: Session;
  baseUrl: string;

  transactionData;
  inputSelectAccountObject: InputSelectAccountObject;

  // mobile?
  mobile = false;
  tablet = false;
  smallDesktop = false;
  timeRemaining = 1800;
  secondCountdown = 0;
  timeRemainingInterval;
  public paymentKey: string;
  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private store: Store
  ) {

    this.timeRemainingInterval = setInterval(() => {
      if (this.timeRemaining === 0) {
        clearInterval(this.timeRemainingInterval);
        this.router.navigate(['transaction-status']);
      }
      // Decrement time remaining in 1s intervals
      this.timeRemaining -= 1;
      // Change e.g 4:00 next count to 3:59 and don't decrement afterwards,
      // I suppose it could be changed to 60 and decremented but ¯\_(ツ)_/¯
      if (this.secondCountdown === 0) {
        this.secondCountdown = 59;
      } else {
        this.secondCountdown -= 1;
      }
    }, 1000);
  }
  /** Slice a smaller string out of a bigger string and return the new, modified string */
  /**
   *
   * @param fullStr bigger string to slice smaller string out of
   * @param sliceStr string to slice out of bigger string
   */
  sliceAndReturnNewString(fullStr: string, sliceStr: string): string {
    const firstHalfString = fullStr.slice(0, fullStr.indexOf(sliceStr)).trim();
    const lastHalfString = fullStr.slice(fullStr.indexOf(sliceStr) + sliceStr.length);
    return firstHalfString + lastHalfString;
  }

  uxFriendlyTime(time: number) {
    return `${Math.floor(time / 60)}:${this.secondCountdown.toString().length <= 1 ? '0' + this.secondCountdown.toString() : this.secondCountdown.toString()}`;
  }

  ngAfterContentInit(): void {

    this.baseUrl = window.location.protocol + '//' +  window.location.host + '/';
    console.log(this.baseUrl);

    this.sessionStorage$.subscribe((data: Session) => {
      this.session = data;
    });

    $(() => {
      $('#pay-button').on('click', () => {
        $(this).hide();
        var paymentKey = sessionStorage.getItem('eftPaymentKey');
        this.paymentKey = paymentKey;
        // @ts-ignore
        eftSec.checkout.init({
          paymentKey: paymentKey,
          onCancelUrl:
            `/transaction-status/eft`,
          onCompleteUrl: `/transaction-status/eft`,
          onErrorUrl: `/transaction-status/eft`,
          onExpireUrl: `/transaction-status/eft`,
          cancelUrl:`/transaction-status/eft`,
          errorUrl:`/transaction-status/eft`,
          successUrl:`/transaction-status/eft`,
          notifyUrl:`/transaction-status/eft`,
          onLoad: () => {
            $('#pay-button').show();
            this.popupOpened = true;
          },
          onCancel: () => {
            $('#pay-button').hide();
            this.popupOpened = false;
            this.reopenPopup = true;
            console.log('Cancel!!');
          }
        });
      });
    });
  }

  ngOnInit(): void {

    this.paymentkey$.pipe(
      catchError((err) => {
        return throwError(err);
      })
    );

    this.themeColour = (document.querySelector('.header-container') as HTMLElement).style.backgroundColor;
    const popupInterval = setInterval(() => {
      if (this.popupWindowTime === 0) {
        clearInterval(popupInterval);
        return this.payButton?.nativeElement?.click();
      }
      this.popupWindowTime -= 1;
    }, 1000)

  }

  ngOnDestroy() {
    this.popupOpened = false;
  }

  loginBankAccount() {
    (document.getElementById('eftx-button-container').querySelector('button[type=submit]') as HTMLButtonElement).click();
  }

  hover(event: Event, type) {
    let accountCard = (event.target as HTMLElement);

    if (accountCard.nodeName === 'SPAN') {
      accountCard = accountCard.parentElement;
    }

    if (type === 'enter') {
      if (accountCard.id !== 'account-selected')
        accountCard.style.borderColor = this.themeColour;
    } else {
      if (accountCard.id !== 'account-selected')
        accountCard.style.borderColor = 'white';
    }
  }

  selectAccount(event: Event) {
    let accountCard = (event.target as HTMLElement);

    if (accountCard.nodeName === 'SPAN') {
      accountCard = accountCard.parentElement;
    }

    const accountCards = accountCard.parentElement.parentElement.children;

    Array.from(accountCards).forEach((el: HTMLElement) => {
      (el.firstChild as HTMLElement).style.borderColor = 'white';
      (el.firstChild as HTMLElement).id = '';
    });

    accountCard.style.borderColor = this.themeColour;
    accountCard.id = 'account-selected';

    // make it the actual selected option

    const option = (document.querySelector(`option[value="${accountCard.parentElement.id}"]`) as HTMLOptionElement);
    option.selected = true;
  }

  goBack(): void {
    this.router.navigate(['virtual']);
  }

  initPopup(): void {
    return this.payButton?.nativeElement?.click();
  }
}
